import React from 'react';
import { Card, Stack, Title, Alert } from '@mantine/core';
import { primaryColor } from '../../../../../constants/theme';
import { BookingResponseModel } from '../../../../../types/BookingModels';

interface SingleBookingStatusCardProps {
  booking: BookingResponseModel;
  totalCost: number;
  isFinished: boolean;
}

export const SingleBookingStatusCard = ({
  booking,
  totalCost,
  isFinished,
}: SingleBookingStatusCardProps) => {
  return (
    <Card maw={600} mx='auto' shadow='none' withBorder data-testid="single-booking-status-card">
      <Stack>
        <Title order={5}>Overall Status</Title>
        {booking.isCancelled && (
          <Alert variant="outline" color="red" title="Cancelled" data-testid="status-alert-cancelled">
            This booking has been cancelled.
          </Alert>
        )}
        {!booking.isCancelled && !booking.accepted && !booking.rejected && !isFinished && (
          <Alert variant="outline" color="blue" title="Waiting for confirmation" data-testid="status-alert-pending-acceptance">
            This booking is waiting to be accepted or rejected.
          </Alert>
        )}
        {!booking.isCancelled && booking.rejected && (
          <Alert variant="outline" color="red" title="Declined" data-testid="status-alert-declined">
            This booking request has been declined.
          </Alert>
        )}
        {!booking.isCancelled && booking.accepted && booking.paymentStatus !== 'succeeded' && totalCost > 0 && !isFinished && (
          <Alert variant="outline" color="orange" title="Pending payment" data-testid="status-alert-pending">
            This booking is pending payment.
          </Alert>
        )}
        {!booking.isCancelled && booking.paymentStatus !== 'succeeded' && totalCost > 0 && isFinished && (
          <Alert variant="outline" color="red" title="No payment received" data-testid="status-alert-no-payment">
            This conversation did not take place due to lack of payment.
          </Alert>
        )}
        {!booking.isCancelled && booking.accepted && (booking.paymentStatus === 'succeeded' || totalCost === 0) && !isFinished && (
          <Alert variant="outline" color={primaryColor} title="You're all set" data-testid="status-alert-all-set">
            Everything is booked and paid for.
          </Alert>
        )}
        {!booking.isCancelled && (booking.paymentStatus === 'succeeded' || totalCost === 0) && isFinished && (
          <Alert variant="outline" color="gray" title="Conversation finished" data-testid="status-alert-finished">
            The conversation has finished.
          </Alert>
        )}
      </Stack>
    </Card>
  );
};
